import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Rating,
  Container,
  CircularProgress,
} from "@mui/material";
import { useSelector } from "react-redux";
import { axiosInstance } from "../../src/Axios"; // adjust path as needed

const ReviewGen = () => {
  const { id } = useParams(); // customer id
  const { cust, loginInfo } = useSelector((state) => state.home);
  const [review, setReview] = useState("");
  const [reviewId, setReviewId] = useState(null); // store selected review's id
  const [isLoading, setIsLoading] = useState(true);
  const [starValue, setStarValue] = useState(0);

  const fetchRandomReview = async () => {
    try {
      const response = await axiosInstance.get(`/getallreview/${id}`, {
        headers: {
          Accept: "application/json",
        },
      });

      const reviews = response.data.result;

      if (Array.isArray(reviews) && reviews.length > 0) {
        const randomIndex = Math.floor(Math.random() * reviews.length);
        const selected = reviews[randomIndex];
        setReview(selected.custom_review);
        setReviewId(selected.id);
      } else {
        setReview("No reviews available.");
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReview("Failed to load review.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCopyReview = async () => {
    try {
      await navigator.clipboard.writeText(review);



      if (cust?.result?.url) {
        window.location.href = cust.result.url;
      }
    } catch (error) {
      console.error("Error copying or deleting review:", error);
    }
  };

  useEffect(() => {
    fetchRandomReview();

    let starCount = 0;
    const starInterval = setInterval(() => {
      starCount += 1;
      setStarValue(starCount);
      if (starCount === 5) clearInterval(starInterval);
    }, 200);

    return () => clearInterval(starInterval);
  }, [id]);

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Box
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(90deg, #560d70 0%, #1f6f76 100%)",
          backgroundSize: "400% 400%",
          animation: "waterFlow 10s ease-in-out infinite",
          "@keyframes waterFlow": {
            "0%": { backgroundPosition: "0% 50%" },
            "50%": { backgroundPosition: "100% 50%" },
            "100%": { backgroundPosition: "0% 50%" },
          },
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 4,
          width: { xs: "100%", md: "30%" },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "#fff",
            textAlign: "center",
            fontWeight: "bold",
            marginBottom: 4,
          }}
        >
          {cust?.result?.agency_name || "Agency"}
        </Typography>

        <Container maxWidth="sm">
          <Card
            sx={{
              background: "rgba(0, 0, 0, .04)",
              backdropFilter: "blur(20px)",
              borderRadius: 3,
              padding: 2,
              textAlign: "center",
              boxShadow:
                "0px 1px 20px 7px rgba(0, 0, 1, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
            }}
          >
            <CardContent>
              <Rating
                value={starValue}
                readOnly
                sx={{
                  marginBottom: 2,
                  transition: "all 0.2s ease-in-out",
                  filter: "drop-shadow(0px 0px 5px rgba(255, 215, 0, 0.8))",
                  animation: "glow 1.5s ease-in-out infinite alternate",
                  "@keyframes glow": {
                    "0%": {
                      filter: "drop-shadow(0px 0px 5px rgba(255, 215, 0, 0.8))",
                    },
                    "100%": {
                      filter: "drop-shadow(0px 0px 15px rgba(255, 215, 0, 1))",
                    },
                  },
                }}
              />

              <Typography
                variant="body1"
                sx={{
                  color: "#fff",
                  marginBottom: 2,
                  minHeight: "4em",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {isLoading ? (
                  <CircularProgress sx={{ color: "#fff" }} size={24} />
                ) : (
                  review
                )}
              </Typography>
            </CardContent>
          </Card>
        </Container>

        <Button
          variant="contained"
          onClick={handleCopyReview}
          sx={{
            background: "rgba(0, 0, 0, .04)",
            backdropFilter: "blur(20px)",
            color: "#fff",
            fontWeight: "bold",
            borderRadius: 20,
            padding: "15px 35px",
            boxShadow:
              "0px 1px 20px 7px rgba(0, 0, 1, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
          }}
        >
          <ContentCopyIcon sx={{ marginRight: "5px" }} />
          COPY REVIEW
        </Button>

        <Box sx={{ display: "flex", alignItems: "center", marginTop: 4 }}>
          <Typography sx={{ color: "#fff", marginRight: 1 }}>Powered By</Typography>
          <Typography sx={{ color: "#fff", fontWeight: "bold" }}>
            {window.location.hostname}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ReviewGen;
